/**
 * Transforme la réponse de GET /hr/pilotage/retention en modèle
 * consommé par RetentionSection. Les valeurs `null` de l'API sont
 * conservées (affichées "—").
 */
export const mapRetention = (api) => ({
    tauxRetention: api.retention_rate ?? null,
    confirmationEssai: api.probation_confirmation_rate ?? null,
    recrutementReussi: api.successful_recruitment_12m ?? null,
    anciennete: api.average_tenure ?? null,
    mobilite: api.internal_mobility_rate ?? null,
});
